import { render } from "./thumbnail-image.vue?vue&type=template&id=3ea823e2"
import script from "./thumbnail-image.vue?vue&type=script&lang=js"
export * from "./thumbnail-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__